export default "https://cdn-static.gokick.com/assets/e21cd8011b9b3a74c4cd288f1b94a870d12ac47c/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";